import React, {useState} from 'react';

const initialState: any = {
  fields: {},
  errors: {},
  validations: {},
};

export interface FormContextInterface {
  fields: Object;
  dbType: string;
  errors: Object;
  setAndValidateFieldValue: (fieldName: string, fieldValue: any) => void;
  setFieldError: (fieldName: string, errorMessage: string) => void;
  registerValidation: (
    fieldName: string,
    validation: (fieldValue: any, fields?: Object) => string | undefined
  ) => void;
  runValidation: (fieldName: string, fieldValue: any) => void;
  unsetFieldError: (fieldName: string) => void;
  resetFormContext: () => void;
  validateForm: () => boolean;
  validateNewForm: (p) => boolean;
}

export const FormContext =
  React.createContext<FormContextInterface>(initialState);

export const FormContextProvider = ({children}) => {
  const [fields, setFields] = useState({});
  const [errors, setErrors] = useState({});
  const [validations, setValidations] = useState({});

  const [dbType, setDbType] = useState('');

  const runValidation = (fieldName, value) => {
    try {
      const errorMsg =
        validations[fieldName] instanceof Function &&
        validations[fieldName](value, fields);
      if (errorMsg) {
        setFieldError(fieldName, errorMsg);
      } else {
        unsetFieldError(fieldName);
      }
    } catch (error) {
      console.error(
        `Validation function error in field: ${fieldName}: `,
        error
      );
    }
  };

  const setAndValidateFieldValue = (fieldName, fieldValue) => {
    if (fieldName === 'type') {
      setDbType(fieldValue);
    }
    setFields((state) => ({
      ...state,
      [fieldName]: fieldValue,
    }));
    if (validations[fieldName]) runValidation(fieldName, fieldValue);
  };

  const setFieldError = (fieldName, errorMessage) => {
    setErrors((state) => ({
      ...state,
      [fieldName]: errorMessage,
    }));
  };
  const unsetFieldError = (fieldName) => {
    setErrors((state) => {
      const newState = state;
      delete newState[fieldName];
      return newState;
    });
  };

  const registerValidation = (fieldName, validation) => {
    setValidations((state) => ({
      ...state,
      [fieldName]: validation,
    }));
  };

  const resetFormContext = () => {
    setFields({});
    setErrors({});
    setValidations({});
  };

  const validateForm = () => {
    let isValid = true;
    Object.keys(validations).forEach((key) => {
      const errorMsg =
        validations[key] instanceof Function &&
        validations[key](fields[key], fields);
      if (errorMsg) {
        isValid = false;
        setFieldError(key, errorMsg);
      }
    });
    return isValid;
  };
  // this validation code for query page alone
  const validateNewForm = (p) => {
    let isValid = true;
    for (var key in validations) {
      if (
        p !== 'audienceMatching_enrichment' &&
        (key === 'expirationDays' ||
          key === 'AllAttributesSelected' ||
          key === 'daysfield' ||
          key === 'hoursfield' ||
          key === 'minutesfield')
      ) {
        delete validations[key];
      }
    }
    Object.keys(validations).forEach((key) => {
      const errorMsg =
        validations[key] instanceof Function &&
        validations[key](fields[key], fields);
      if (errorMsg) {
        isValid = false;
        setFieldError(key, errorMsg);
      }
    });
    return isValid;
  };

  return (
    <FormContext.Provider
      value={{
        fields,
        dbType,
        errors,
        setAndValidateFieldValue,
        setFieldError,
        registerValidation,
        runValidation,
        unsetFieldError,
        resetFormContext,
        validateForm,
        validateNewForm,
      }}
    >
      {children}
    </FormContext.Provider>
  );
};
